import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
var AccountMenu = function (props) {
    var _a = useState(false), expanded = _a[0], setExpanded = _a[1];
    var history = useHistory();
    useEffect(function () {
        setExpanded(props.expanded);
    }, [props.expanded]);
    var path = window.location.pathname;
    return (React.createElement("div", { className: "AccountMenu" },
        React.createElement("div", { className: "container " + (expanded ? 'slide-down' : 'slide-up') },
            React.createElement("nav", null,
                React.createElement("ul", null,
                    React.createElement("li", { className: "text " + ((path === '/account' || path === '/billing') ? 'selected' : ''), onClick: function () { history.push('/account'); } }, "My Account"),
                    React.createElement("li", { className: "text", onClick: props.onEnterFullScreen }, props.isFullScreen ? 'Exit Fullscreen' : 'Enter Fullscreen'),
                    React.createElement("li", { className: "text", onClick: function () { return window.location.href = "mailto:info@bpmsupreme.com?subject=" + 'BPM Create Support Request'; } }, "Support"),
                    React.createElement("li", { className: "text", onClick: props.onLogout }, "Logout"))))));
};
export default AccountMenu;
//# sourceMappingURL=AccountMenu.js.map